"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Pagers = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const outputs_1 = require("./outputs");
exports.Pagers = styled_components_1.default(outputs_1.Outputs) `
  background-color: var(--theme-pager-bg, #fafafa);
`;
exports.Pagers.displayName = "Pagers";
exports.default = exports.Pagers;
//# sourceMappingURL=pagers.js.map